<template>
    <div id="amf-help-hint-icon" style="position: absolute; display:none">
      <div class="fa fa-question-circle-o"></div>
      <div id="amf-help-hint-content"></div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
    }

</script>

<style lang="scss">

#amf-help-hint-content {
    border: 1px solid black;
    border-radius: 5px;
    margin-left: 10px;
    background-color: white;
    color: black;
    padding: 5px;
    display: none;
    max-width: 300px;

    b, strong {
        font-weight: bold !important;
    }
}

</style>


// WEBPACK FOOTER //
// src/framework/primitives/AmfHelpHintIcon.vue